import {
  USER_INFO,
  ERROR,
  SUCCESS,
  GET_TECHNOLOGIES,
  GET_SELECTED_MENU,
  GET_MENUS,
  GET_USER_PERMISSIONS,
  GET_ALL_STRUCTURE,
  SYSTEM_SETTINGS,
  GET_WHOLE_STRUCTURE

} from "./type";

const initialState = {
  loggedUser: null,
  errorMessage: null,
  successMessage: null,
  technologies: [],
  menus: [],
  userPermissions: [],
  selectedMenu: null,
  structures: [],
  systemSettings: null,
  wholeStructure: []


};

export const userReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case USER_INFO:
      return { ...state, loggedUser: payload };
    case ERROR:
      return { ...state, errorMessage: payload };
    case GET_SELECTED_MENU:
      return { ...state, selectedMenu: payload };
    case SUCCESS:
      return { ...state, successMessage: payload };
    case GET_TECHNOLOGIES:
      return { ...state, technologies: payload };
    case GET_MENUS:
      return { ...state, menus: payload };
    case GET_USER_PERMISSIONS:
      return { ...state, userPermissions: payload };
    case GET_ALL_STRUCTURE:
      return { ...state, structures: payload };
    case SYSTEM_SETTINGS:
      return { ...state, systemSettings: payload };
    case GET_WHOLE_STRUCTURE:
      return { ...state, wholeStructure: payload };
    default:
      return state;
  }
};
